import React from 'react';
import { EditIcon, CalendarIcon, DollarSignIcon, Trash2Icon, UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export interface Earning {
  id: string;
  amount: number;
  date: string;
  type: 'Ladeboks' | 'Andet';
  customerId?: string;
  customerName?: string;
  notes?: string;
}
interface EarningCardProps {
  earning: Earning;
  index: number;
  onEdit: (earning: Earning) => void;
  onDelete: (earning: Earning) => void;
  readOnly?: boolean;
}
export function EarningCard({
  earning,
  index,
  onEdit,
  onDelete,
  readOnly = false
}: EarningCardProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.3,
    delay: index * 0.05
  }} className="bg-white rounded-xl p-5 shadow-sm border border-stone-100 hover:shadow-md transition-shadow duration-200" data-id="element-247" data-mp="gew4vacwc6aw">
      <div className="flex items-start justify-between mb-3" data-id="element-248" data-mp="2w8mqnmhbtlwu">
        <div className="flex-1" data-id="element-249" data-mp="v1oqax3f5ql6">
          <div className="flex items-center gap-2 mb-2" data-id="element-250" data-mp="v1ezx8egphey">
            <span className={`px-3 py-1 text-xs font-medium rounded-full border ${earning.type === 'Ladeboks' ? 'bg-blue-100 text-blue-700 border-blue-200' : 'bg-purple-100 text-purple-700 border-purple-200'}`} data-id="element-251" data-mp="zzyhkwm0w71i">
              {earning.type}
            </span>
          </div>
          <div className="flex items-center gap-2 text-sm text-stone-500 mb-2" data-id="element-252" data-mp="c92xklnt6g4t">
            <CalendarIcon className="w-4 h-4 text-teal-600" data-id="element-253" data-mp="h1dx3nemzzwu" />
            <span data-id="element-254" data-mp="h2xejhc14h07">{new Date(earning.date).toLocaleDateString('da-DK')}</span>
          </div>
          {earning.customerName && <div className="flex items-center gap-2 text-sm text-stone-600" data-id="element-255" data-mp="7ark80yb1nhu">
              <UserIcon className="w-4 h-4 text-blue-600" data-id="element-256" data-mp="78ol8rf6ck0z" />
              <span className="font-medium" data-id="element-257" data-mp="3phz10psew2t3">{earning.customerName}</span>
            </div>}
        </div>
        {!readOnly && <div className="flex items-center gap-1" data-id="element-258" data-mp="3uhlen0c5jl2f">
            <button onClick={() => onEdit(earning)} className="p-1.5 text-stone-400 hover:text-teal-600 hover:bg-teal-50 rounded-lg transition-all" aria-label="Rediger indtjening" data-id="element-259" data-mp="200bv0cg1p5ot">
              <EditIcon className="w-4 h-4" data-id="element-260" data-mp="1r4uf3a8e4ecl" />
            </button>
            <button onClick={() => onDelete(earning)} className="p-1.5 text-stone-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all" aria-label="Slet indtjening" data-id="element-261" data-mp="1m9f6awp8p8n1">
              <Trash2Icon className="w-4 h-4" data-id="element-262" data-mp="2euyibgho2c32" />
            </button>
          </div>}
      </div>

      {earning.notes && <div className="text-sm text-stone-600 mb-4 line-clamp-2" dangerouslySetInnerHTML={{
      __html: earning.notes
    }} data-id="element-263" data-mp="24z4x78pvta9o" />}

      <div className="pt-4 border-t border-stone-100" data-id="element-264" data-mp="tjg9ug8pu98c">
        <div className="flex items-center justify-between" data-id="element-265" data-mp="thvfaqmeiqah">
          <div className="flex items-center gap-2" data-id="element-266" data-mp="jg1hiqtfv735">
            <DollarSignIcon className="w-4 h-4 text-emerald-600" data-id="element-267" data-mp="jhcikivi20qk" />
            <span className="text-sm text-stone-500" data-id="element-268" data-mp="ofnur099onby">Beløb</span>
          </div>
          <span className="text-xl font-bold text-emerald-700" data-id="element-269" data-mp="td5y8b4imack">
            +{earning.amount.toLocaleString('da-DK')} kr
          </span>
        </div>
      </div>
    </motion.article>;
}